import React from 'react';

import {CheckboxSkeleton, FormSectionSkeleton} from 'src/components/skeleton';

export const PbWorkspaceSettingsSkeleton = () => (
    <FormSectionSkeleton labelWidth={200}>
        <CheckboxSkeleton labelWidth={182}/>
    </FormSectionSkeleton>
);
